<script lang="ts" setup>
import { CircleInfoIcon } from 'Common/components/elements/icons/Icons'
import { DAMAGE_TYPE_STROKE_COLOR } from './constants'
import { DefectCategories } from 'Modules/types/pages/imageReview/enums'
import { computed } from 'vue'

const gridData = computed(() => {
  const tempData = []
  Object.keys(DefectCategories).forEach((key) => {
    const category = DefectCategories[key as keyof typeof DefectCategories]
    tempData.push({
      category: category,
      color: `<div class="w-4 h-4 bg-[${[DAMAGE_TYPE_STROKE_COLOR[category]]}]"></div>`,
    })
  })
  return tempData
})
</script>

<template>
  <div style="display: flex; align-items: center">
    <el-popover
      :width="200"
      popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
    >
      <template #reference>
        <CircleInfoIcon class="pr-2 text-je-dark-blue"></CircleInfoIcon>
      </template>
      <template #default>
        <div satyle="display: flex; gap: 16px; flex-direction: column">
          <el-table :data="gridData">
            <el-table-column width="25" property="color">
              <template #default="{ row }">
                <div v-html="row.color"></div>
              </template>
            </el-table-column>
            <el-table-column width="125" property="category" label="Category" />
          </el-table>
        </div>
      </template>
    </el-popover>
  </div>
</template>
